// Phone photos are 3-5 MB and 4000+ px wide. Bills are read fine at ~2400 px, so shrink in the browser before uploading:
// faster on mobile data and far below the server's upload limit. Anything that cannot be shrunk is sent as it was.

const MAX_SIDE = 2400;            // long side, in pixels
const QUALITY = 0.85;             // JPEG quality
const LEAVE_ALONE_BYTES = 1024 * 1024;   // already small and not oversized: keep the original untouched

const loadBitmap = async (file) => {
  if (typeof createImageBitmap === 'function') {
    try { return await createImageBitmap(file, { imageOrientation: 'from-image' }); } catch (e) { /* fall through */ }
  }
  return new Promise((resolve, reject) => {          // older browsers: an <img> applies the EXIF rotation itself
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = (e) => { URL.revokeObjectURL(url); reject(e); };
    img.src = url;
  });
};

/** Returns a smaller JPEG File, or the original file when it is already small, not an image, or cannot be processed. */
export async function shrinkImage(file) {
  try {
    if (!file || !(file.type || '').startsWith('image/')) return file;
    const bmp = await loadBitmap(file);
    const w = bmp.width || bmp.naturalWidth, h = bmp.height || bmp.naturalHeight;
    if (!w || !h) return file;
    const scale = Math.min(1, MAX_SIDE / Math.max(w, h));
    if (scale === 1 && file.size <= LEAVE_ALONE_BYTES) return file;
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(w * scale);
    canvas.height = Math.round(h * scale);
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#fff';                           // transparent PNGs would otherwise turn black as JPEG
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(bmp, 0, 0, canvas.width, canvas.height);
    if (typeof bmp.close === 'function') bmp.close();
    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', QUALITY));
    if (!blob || blob.size >= file.size) return file;   // never make it bigger
    const name = (file.name || 'bill').replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified });
  } catch (e) {
    return file;
  }
}
